// extracted by mini-css-extract-plugin
export default {"fieldset":"AnthropometryFields_fieldset__6iyo0","select":"AnthropometryFields_select__L1E-0"};